import { HttpContext, HttpContextToken } from '@angular/common/http';

const PUBLIC_ACCESS_ID = new HttpContextToken<string>(() => null);
const BYPASS_PUBLIC_MIDDLEWARE = new HttpContextToken<boolean>(() => false);
const BYPASS_ERROR_MIDDLEWARE = new HttpContextToken<boolean>(() => false);
const BYPASS_DELEGATION_MIDDLEWARE = new HttpContextToken<boolean>(() => false);

/** A managed Http context used to wrap the predefined tokens */
export class ManagedHttpContext extends HttpContext {
  /** An Http context token used to override the public access Id */
  get publicAccessId(): string {
    return this.get(PUBLIC_ACCESS_ID);
  }

  /** An Http context token used to bypass the public middleware */
  get bypassPublicMiddleware(): boolean {
    return this.get(BYPASS_PUBLIC_MIDDLEWARE);
  }
  /** An Http context token used to bypass the public middleware */
  get bypassErrorMiddleware(): boolean {
    return this.get(BYPASS_ERROR_MIDDLEWARE);
  }

  /** An Http context token used to bypass the delegation middleware */
  get bypassDelegationMiddleware(): boolean {
    return this.get(BYPASS_DELEGATION_MIDDLEWARE);
  }

  /**
   * A managed Http context used to wrap the predefined tokens.
   * @param tokens Predefined Http context tokens.
   */
  constructor(tokens?: {
    /** An Http context token used to override the public access Id */
    publicAccessId?: string;
    /** An Http context token used to bypass the public middleware */
    bypassPublicMiddleware?: boolean;
    bypassErrorMiddleware?: boolean;
    bypassDelegationMiddleware?: boolean;
  }) {
    super();

    if (tokens?.publicAccessId) {
      this.set(PUBLIC_ACCESS_ID, tokens.publicAccessId);
    }

    if (tokens?.bypassPublicMiddleware) {
      this.set(BYPASS_PUBLIC_MIDDLEWARE, tokens.bypassPublicMiddleware);
    }
    if (tokens?.bypassErrorMiddleware) {
      this.set(BYPASS_ERROR_MIDDLEWARE, tokens.bypassErrorMiddleware);
    }

    if (tokens?.bypassDelegationMiddleware) {
      this.set(BYPASS_DELEGATION_MIDDLEWARE, tokens.bypassDelegationMiddleware);
    }
  }

  /** Create a new HttpContextHandler from the passed context */
  static create(context: HttpContext): ManagedHttpContext {
    return Object.assign(new ManagedHttpContext(), context);
  }
}
